import { useEffect, useState } from "react";
import { submitLead } from "../services/leads";

// Same lead submission as the contact page (components/Form.jsx), presented as
// a modal and pre-filled with the residence being inquired about.

const BEDS_TO_LAYOUT = { 0: "studio", 1: "1-bed", 2: "2-bed", 3: "3-bed" };

export default function InquireModal({ listing, onClose }) {
  const [isFormSent, setFormSent] = useState(false);
  const [sendError, setSendError] = useState(false);

  useEffect(() => {
    const onKeyDown = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [onClose]);

  const formSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    const { full_name, email, phone_number, layout, move_in_date, message } =
      Object.fromEntries(new FormData(form));
    setSendError(false);
    submitLead({ full_name, phone_number, email, layout, move_in_date, message })
      .then(() => {
        form.reset();
        setFormSent(true);
      })
      .catch(() => setSendError(true));
  };

  const unitLabel = [listing.unit ? `Residence ${listing.unit}` : null, listing.building]
    .filter(Boolean)
    .join(" at ");

  return (
    <div className="inquire-modal" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="panel" role="dialog" aria-modal="true" aria-label="Inquire about this residence">
        <svg
          className="close"
          onClick={onClose}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19 5L5 19M5 5L19 19"
            stroke="#f4e9d7"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
        </svg>
        {isFormSent ? (
          <div className="thankyou">
            <h2>Thank you!</h2>
            <p>We’ll be in touch</p>
            <button type="button" className="button submit" onClick={onClose}>
              Close
            </button>
          </div>
        ) : (
          <>
            <h3>Inquire</h3>
            {unitLabel && <p className="subtitle">{unitLabel}</p>}
            <form onSubmit={formSubmit}>
              <input
                className="form-control-input"
                type="text"
                placeholder="Full Name"
                name="full_name"
                required
              />
              <input
                className="form-control-input"
                type="email"
                placeholder="Email address"
                name="email"
                required
              />
              <input
                className="form-control-input"
                type="tel"
                placeholder="Phone number"
                name="phone_number"
                pattern="[0-9\-]*"
                required
              />
              <div className="select-wrap">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.29289 8.29289C4.68342 7.90237 5.31658 7.90237 5.70711 8.29289L12 14.5858L18.2929 8.29289C18.6834 7.90237 19.3166 7.90237 19.7071 8.29289C20.0976 8.68342 20.0976 9.31658 19.7071 9.70711L12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071L4.29289 9.70711C3.90237 9.31658 3.90237 8.68342 4.29289 8.29289Z"
                    fill="#f4e9d7"
                  ></path>
                </svg>
                <select
                  className="form-control-input"
                  name="layout"
                  defaultValue={BEDS_TO_LAYOUT[listing.bedrooms] ?? ""}
                  required
                >
                  <option value="" disabled>
                    Desired Layout
                  </option>
                  <option value="studio">Studio</option>
                  <option value="1-bed">1 Bed</option>
                  <option value="2-bed">2 Bed</option>
                  <option value="3-bed">3 Bed</option>
                </select>
              </div>
              <input
                className="form-control-input"
                type="date"
                aria-label="Move-in date"
                name="move_in_date"
                required
              />
              <textarea
                onChange={(e) => {
                  e.target.style.height = "5px";
                  e.target.style.height = e.target.scrollHeight + "px";
                }}
                name="message"
                placeholder="Message"
                rows="3"
                defaultValue={unitLabel ? `I'm interested in ${unitLabel}. Please send me more information.` : ""}
                required
              />
              <button type="submit" className="button submit">
                Submit
              </button>
              {sendError && (
                <p className="lead-error">
                  Something went wrong sending your inquiry. Please try again, or call us
                  at <a href="tel:5162120430">(516) 212-0430</a>.
                </p>
              )}
            </form>
            <p className="call">
              Or call us at <a href="tel:5162120430">(516) 212-0430</a>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
